export const environment = {
  production: false,
  apiUrl: 'https://p4qkeqvgzl.execute-api.us-east-1.amazonaws.com/dev',
  version: '1.0.42'
};
